import { render, staticRenderFns } from "./Man.vue?vue&type=template&id=6bae5795&scoped=true&"
import script from "./Man.vue?vue&type=script&lang=js&"
export * from "./Man.vue?vue&type=script&lang=js&"
import style0 from "./Man.vue?vue&type=style&index=0&id=6bae5795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae5795",
  null
  
)

export default component.exports